import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { createLoadingSelector } from '@hobs/utils/loading';
import { withTranslation } from 'react-i18next';
import _ServiceRequest from '@hobs/containers/ServiceRequest';
import { getAnnexesTree } from '@hobs/actions/annex';
import { queryLocations } from '@hobs/actions/locations';
import { queryOData, resetOData } from '@hobs/actions/odata';
import {
  uploadAttachments,
  setAttachments,
  deleteAttachment,
  clearAttachments
} from '@hobs/actions/attachment';
import { createAdditionalServiceRequest } from '@hobs/actions/additionalServiceRequest';
import {
  forSubmit as forTransportationSubmit
} from '@hobs/actions/transportation';
import {
  calculateByDays,
  clearCalculateByDays,
  forSubmit,
  create
} from '../../actions/serviceRequests';

class ServiceRequest extends _ServiceRequest {
  loadRequiredData() {
    this.props.forSubmit();
    this.props.getAnnexesTree();
    this.queryOdata();
    this.props.forTransportationSubmit();
  }

  getServiceRequestsGridUrl() {
    return '/requested-services';
  }

  getCatalogItemsQueryUrl() {
    return 'CatalogItemsQueryForServiceRequest';
  }

  getCustomServiceRequestUrl() {
    return '/custom-service-request';
  }

  getServiceRequestEditUrl(serviceRequestId) {
    return `/service-request/${serviceRequestId}`;
  }

  renderTransportationInfo() {}

  renderGeneralInformation() {}
}

const oDataLoading = createLoadingSelector(['OData']);
const mapStateToProps = state => ({
  isLoading: oDataLoading(state),
  annexesTree: state.annex.tree,
  oData: state.odata,
  query: state.locations.query,
  calculateByDaysResults: state.serviceRequests.calculateByDays,
  forSubmitData: state.serviceRequests.forSubmit,
  attachments: state.attachment.attachments,
  forTransportationSubmitData: state.transportation.forSubmit
});

const mapDispatchToProps = {
  getAnnexesTree,
  queryOData,
  queryLocations,
  resetOData,
  calculateByDays,
  clearCalculateByDays,
  forSubmit,
  create,
  uploadAttachments,
  setAttachments,
  deleteAttachment,
  clearAttachments,
  createAdditionalServiceRequest,
  forTransportationSubmit
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withRouter(ServiceRequest)));
